import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    email = '',
    password = '',
    verifyCode = '',
    codeId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.setCurrentEmail, {
        email,
        password,
        verifyCode,
        codeId,
    }, options);
    if (error) return { error, status };
    return content || {};
};

